import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../../css/StorageBanner.css';

const BLUEBIRD_DOCS_URL = 'https://bluebird-documentation.com/';

const StorageBanner = ({ onDismiss }) => {
    const { user } = useAuth();

    return (
        <div className="StorageBanner">
            <div className="StorageBanner__content">
                <span className="StorageBanner__icon">⚠</span>
                <div className="StorageBanner__text">
                    <strong>Storage limit reached.</strong> You can't create new boards or tasks until you free up space or upgrade your plan.
                </div>
            </div>
            <div className="StorageBanner__actions">
                <a
                    className="StorageBanner__manage-btn"
                    href={`${BLUEBIRD_DOCS_URL}/account/${user?.uid}/storage`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Manage Storage
                </a>
                {onDismiss && (
                    <button className="StorageBanner__dismiss" onClick={onDismiss}>
                        ×
                    </button>
                )}
            </div>
        </div>
    );
};

export default StorageBanner;
